module.exports = __webpack_public_path__ + "static/img/chuhuono.7fddb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuhuono.png
// module id = 1qMT
// module chunks = 128